import { useSyncExternalStore } from "react";

export const AUTH_RECOVERY_HEADER = "x-bff-auth-recovery";

let opened = false;
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function showAuthError(): void {
  if (opened) {
    return;
  }
  opened = true;
  notify();
}

export function useAuthError(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    () => opened
  );
}
